export const LIMITED_SLACK_PERMISSIONS = 'limited-slack-permissions';
export const INSIGHTS_DASHBOARD = 'insights-dashboard';
export const OUTLOOK_EDITOR_IMAGES = 'outlook-editor-images';
export const AI_INTEGRATION_V1 = 'ai_integration_v1';
export const LARGE_CALENDAR_SPLIT = 'split-large-calendar-events';
export const NOTIFICATIONS_V2 = 'notifications-v2';
export const COMMUNITIES = 'communities';
export const PUBLIC_API = 'public-api';
export const PUBLIC_API_V2 = 'public-api-v2';
export const COMMUNITIES_INSIGHTS = 'communities-insights';
export const EVENT_EDITOR_V2 = 'event_editor_v2';

// Invitaion rewrite
export const GUEST_CAP = 'guest-cap';

// T2 Domain:
export const T2_DOMAIN = 't2_domain_enum';

// Slack revamp
export const SLACK_REVAMP = 'slack-revamp';

// Slack enterprise shared channels (requires SLACK_REVAMP as prerequisite)
export const SLACK_ENTERPRISE_SHOW_SHARED = 'slack_enterprise_show_shared';

// Databricks: reduced Slack OAuth scope set
export const DATABRICKS_LIMITED_SLACK_PERMS = 'databricks_limited_slack_permissions';

// Epoch-agent-v1
export const AGENT_EPOCH_V1 = 'agent_epoch_v1';
export const AGENT_INSIGHTS_VANNA = 'agent_insights_vanna';
export const AGENT_EPOCH_INSIGHTS = 'agent_epoch_insights';

// Plus one guests
export const PLUS_ONE_GUESTS = 'plus_one_guests';
